import React, { useContext, useEffect, useRef, useState } from 'react'
import MenuHeader from './../MenuHeader'
import { ProductContext } from '../../../../store'
import { Form, FormGroup, Input } from 'reactstrap'
import DetailSkeleton from '../../../Skeleton/DetailSkeleton'
import Select from 'react-select'

const GeneralCategory = ({type}) => {
	const divRef = useRef(null),
		[categoryDropdown, setCategoryDropdown]	= useState([]),
		[pageLoader, setPageLoader]	= useState(true),
		[openSelect, setOpenSelect]	= useState(false),
		[height, setHeight] = useState("100vh"),
		{
			setCategoryId,
			setProductPage,
			setProducts,
			setOriginalProducts,
			setOriginalProductOrder,
			categoryId,
			description,
			setDescription,
			categories,
			setEnableSave,
			setBuried,
			setPinnedItems,
			setHiddenProductIndex,
			setPinnedProductIndex,
			setHidden,
			setPromoted,
			setBuriedProducts,
			setHiddenProducts,
			editCategoryMerchandising,
			setSelectedPromoTiles,
			channelId,
			setChannelId,
			channels,
			channelLoader
		}	= useContext(ProductContext)

	useEffect(() => {
		if( Object.keys(channels).length > 0 ){
			setChannelId(Object.keys(channels)[0])
		}
	}, [channels])
	
	useEffect(() => {
		const calculateHeight = () => {
			if (divRef.current) {
			  const topPosition = divRef.current.getBoundingClientRect().top
			  const newHeight = `calc(100vh - ${topPosition}px)`
			  setHeight(newHeight)
			}
		 }
		 // Calculate height initially
		 calculateHeight()
	
		 // Recalculate height on window resize
		 window.addEventListener("resize", calculateHeight)
		 return () => {
			window.removeEventListener("resize", calculateHeight)
		 }
	}, [divRef])

	useEffect(() => {
		let categoryDropdownLocal	= []
		let categoryItems	= categories
		for( let i = 0; i <  categoryItems.length; i++ ){
			let currentCategory	= categoryItems[i],
				categoryDropdownValue	= {value: currentCategory.categoryId, label: currentCategory.categoryName + ' - ' + currentCategory.categoryUrl}
			categoryDropdownLocal.push(categoryDropdownValue)
		}
		setCategoryDropdown(categoryDropdownLocal)
		setPageLoader(false)
	}, [categories])	

	const updateCategoryId = (categoryId) => {
		setEnableSave(false)
		setProductPage(1)
		setProducts([])
		setBuried([])
		setHidden([])
		setPromoted([])
		setBuriedProducts([])
		setHiddenProducts([])
		setOriginalProducts([])
		setPinnedItems({})
		setHiddenProductIndex({})
		setPinnedProductIndex({})
		setSelectedPromoTiles({})
		setCategoryId(categoryId)
	}

	return (
		<React.Fragment>
			<MenuHeader title={"General"} />
			<div className='sideBarMenuGridContainer' ref={divRef} style={{height: height, position: "relative"}}>
				<div className='menuContentWrapper'>
					<div className="d-flex flex-column p-4">
						{(pageLoader || channelLoader) ?
							<DetailSkeleton />
						:
							<Form onSubmit={(e) => e.preventDefault()}>
								<FormGroup style={{marginBottom:"20px"}}>
									<div className={`${openSelect ? "categorySelectable" : ""}`}>
										{type === "new" ?
											<>
												<label style={{ display: 'block', marginBottom: '4px', fontWeight: 'bold' }}>
													Category (Required)
												</label>
												<Select
													isSearchable={true}
													placeholder="Select Category"
													maxMenuHeight={300}
													isRequired={true}
													menuPosition="fixed"
													menuPlacement="bottom"
													value={categoryId ? 
														categoryDropdown.find(option => option.value === categoryId) : null
													}
													options={categoryDropdown}
													onChange={(selectedOption) => updateCategoryId(selectedOption?.value)}
													onMenuOpen={() => setOpenSelect(true)}
													onMenuClose={() => setOpenSelect(false)}
												/>
											</>
										:
											<>
												<h4 className='mb-2 font-bold'>Categories</h4>
												<h6>{editCategoryMerchandising?.categoryName}</h6>
											</>
											
										}
									</div>
								</FormGroup>
								<FormGroup style={{marginBottom: "20px"}}>
									<Input
										type="textarea"
										label="Description"
										onChange={(e) => setDescription(e.target.value)}
										placeholder="Description"
										rows={3}
										resize={"true"}
										value={description}
									/>
								</FormGroup>
							</Form>
						}
					</div>
				</div>
			</div>
		</React.Fragment>
	)
}
export default GeneralCategory